export default __webpack_public_path__ + "images/designer_placeholder_logo_518fb8b5ec2b48c7c4bd456a82583718.png";